import {
  Card,
  makeStyles,
  tokens,
} from '@fluentui/react-components';
import React from 'react';
import { Outlet } from 'react-router-dom';

const useStyles = makeStyles({
  content: {
    padding: `0 ${tokens.spacingHorizontalL}`,
    height: '100%',
    width: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  card: {
    height: '100%',
    width: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
});

const PageContent: React.FC = () => {
  const styles = useStyles();

  return (
    <div className={styles.content}>
      <Card className={styles.card}>
        <Outlet />
      </Card>
    </div>
  );
};

export default PageContent;
